export default "__VITE_ASSET__hzhmoCwh__"